import { render, staticRenderFns } from "./ShipmentForm.vue?vue&type=template&id=4762e2a6&scoped=true"
import script from "./ShipmentForm.vue?vue&type=script&lang=js"
export * from "./ShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./ShipmentForm.vue?vue&type=style&index=0&id=4762e2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4762e2a6",
  null
  
)

export default component.exports